export default __webpack_public_path__ + "static/media/nav_detail_img_10.ad7bca49.jpg";